var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-button",
    {
      attrs: {
        size: _vm.size,
        type: _vm.type,
        icon: _vm.icon,
        round: _vm.round,
        plain: _vm.plain,
        circle: _vm.circle,
        autofocus: _vm.autofocus,
        loading: _vm.loading,
        disabled: _vm.disabled
      },
      on: { click: _vm.onPress }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }